import { render, staticRenderFns } from "./CollageManual.vue?vue&type=template&id=1fb4356b"
import script from "./CollageManual.vue?vue&type=script&lang=js"
export * from "./CollageManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports